import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { isBet, isBetArray } from '../../../../../schema/coupon/entry.js';
import { CouponEntity } from '../../../../domain/entry.js';
/**
 * Calculates system size based on raw outcome groups.
 * Used for calculating system size from outcome data that doesn't have a complete Board structure.
 *
 * For single-row coupons, system size is always 1.
 * For multi-system coupons, system size is calculated based on outcome distribution.
 *
 * @param root0 Hook arguments
 * @param root0.outcomes Raw outcome groups for each event
 * @param root0.isSingleRow Whether this is a single-row coupon (4D array). If omitted, returns 0 for empty outcomes or uses multi-system calculation.
 * @returns The calculated system size for the given outcomes
 */
export function useOutcomesSystemSize(t0) {
  const $ = _c(2);
  const {
    outcomes,
    isSingleRow
  } = t0;
  let t1;
  bb0: {
    if (isSingleRow && isBetArray(outcomes)) {
      t1 = 1;
      break bb0;
    }
    if (isBet(outcomes)) {
      let t2;
      if ($[0] !== outcomes) {
        t2 = CouponEntity.getSystemSizeFromOutcomes(outcomes);
        $[0] = outcomes;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      t1 = t2;
      break bb0;
    }
    t1 = 0;
  }
  return t1;
}